<template>
	<div class="section-img">
		<div v-for="img in data.img" :key="img.id" class="img-wrap">
			<img v-if="img.logo" :src="require(`@/${imgpath}/${filename}/${img.pic}`)" />
			<a v-if="img.logo" class="logo" :class="img.logo.position ? img.logo.position : 'left'" href="https://tj.centanet.com/">
				<img :src="require(`@/assets/images/logo.png`)" />
			</a>
			<img v-else :src="require(`@/${imgpath}/${filename}/${img}`)" />
		</div>
	</div>
</template>

<script>
export default {
	props: ['dataP', 'filenameP', 'imgpathP'],
	data() {
		return {
			data: '',
			filename: '',
			imgpath: ''
		};
	},
	created() {
		this.data = this.dataP;
		this.filename = this.filenameP;
		this.imgpath = this.imgpathP;
	}
};
</script>

<style lang="scss" scoped>
.img-wrap {
	position: relative;

	.logo {
		position: absolute;
    top: 10px;   
    width: 20%;

		&.left{
			left: 10px;
		}

		&.right{
			right: 10px;
		}
	}
}
</style>
